import { PostPreviewProps } from 'components/PostPreviewModal/Types'
import Styles from './PostPreviewDrawerContent.module.scss'
import { PreviewRenderer } from './components/PreviewRenderer/PreviewRenderer'
import { SelectChannels } from './screens/SelectChannels/SelectChannels'
import { PostActions } from './components/PostActions/PostActions'
import { PostScheduler } from './screens/PostScheduler/PostScheduler'
import { observer } from 'mobx-react-lite'
import { usePostPreviewStore } from './PostPreviewStoreProvider'
import { PostPreviewScreens } from './PostPreviewStore'
import { ActionResult } from './screens/ActionResult/ActionResult'
import { PostAction } from './hooks/usePostActionService'
import { PostPreviewProviders } from './Providers'
import { DrawerHeader } from './PostPreviewDrawerV2'

export const DrawerInner = observer(({ pollPreviewContentStream = true, ...props }: PostPreviewProps) => {
  const store = usePostPreviewStore()

  return (
    <div className={Styles.body}>
      {store.screen === PostPreviewScreens.CHANNEL_SCREEN && (
        <div className={Styles.content}>
          <SelectChannels />
        </div>
      )}
      {store.screen === PostPreviewScreens.PREVIEW_SCREEN && (
        <div className={Styles.content}>
          <PreviewRenderer channel={props.channel} pollPreviewContentStream={pollPreviewContentStream} />
          <PostActions />
        </div>
      )}
      {store.screen === PostPreviewScreens.AUTOPOST_CALENDAR_SCREEN && (
        <div className={Styles.content}>
          <PostScheduler action={PostAction.AutoSchedule} />
        </div>
      )}
      {store.screen === PostPreviewScreens.REMINDER_CALENDAR_SCREEN && (
        <div className={Styles.content}>
          <PostScheduler action={PostAction.Reminder} />
        </div>
      )}
      {store.screen === PostPreviewScreens.RESULT_SCREEN && (
        <div className={Styles.content}>
          <ActionResult />
        </div>
      )}
    </div>
  )
})

const PostPreviewDrawerContent = (props: PostPreviewProps & { renderHeader?: boolean }) => (
  <PostPreviewProviders {...props}>
    {props.renderHeader && <DrawerHeader />}
    <DrawerInner {...props} />
  </PostPreviewProviders>
)

export { PostPreviewDrawerContent }
